export const MAX_THREAD_COUNT = 100;